export const groupDataByOrgId = ({ relatedCompanies }) => {
  const objByOrgId = {}
  const dataOrder = []
  relatedCompanies.forEach((el) => {
    if (!objByOrgId[el.organizationId]) {
      dataOrder.push(el.organizationId)
      const newEl = { ...el }
      delete newEl.relationship
      delete newEl.percentage

      objByOrgId[el.organizationId] = {
        ...newEl,
        relationshipGroup: [
          {
            ownerOrganizationId: el.ownerOrganizationId,
            ownerOrganizationName: el.ownerOrganizationName,
            ownerPersonName: el.ownerPersonName,
            relationship: el.relationship,
            percentage: el.percentage,
          },
        ],
      }
    } else {
      objByOrgId[el.organizationId].relationshipGroup = [
        ...objByOrgId[el.organizationId].relationshipGroup,
        {
          ownerOrganizationId: el.ownerOrganizationId,
          ownerOrganizationName: el.ownerOrganizationName,
          ownerPersonName: el.ownerPersonName,
          relationship: el.relationship,
          percentage: el.percentage,
        },
      ]
    }
  })

  return { relatedCompanies: dataOrder.map((val) => objByOrgId[val]) }
}
